import { combineReducers } from 'redux';
import { INotificationsState } from './types';
import { notificationsReducer as notifications, initialState } from './reducers/notifications';

interface INavigationState {
  notifications: INotificationsState;
}

export default combineReducers({ notifications });
export { INavigationState, initialState };
